<template>
<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
    <div class="my-account-title">Forecasting Information</div>
    <div class="account_section_box">
        <div class="row">
            <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                <label class="account_label" v-if="FormInputs.IndividualLabels">Pledged number of orders this year: <span data-balloon="Please provide your best estimate; this does not need to be exact.  You can modify this number from your “My Account” page." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span></label>
                <label class="account_label" v-else>Location's pledged number of orders this year: <span data-balloon="Please provide your best estimate; this does not need to be exact.  You can modify this number from your “My Account” page." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span></label>
            </div>
            <div class="col-lg-3 col-md-5 col-sm-4 col-xs-4">
                <div class="form-group" v-show="FormInputs.OfficeLocationNumberOfJobs">
                    <input v-bind:class="{ error_field: OfficeLocationValidationResult.OfficeLocationNumberOfJobs }" type="number"
                    v-model="AccountEdit.primaryContact.officeLocation.numberOfJobs" class="form-control input_field"
                    v-on:keypress="G_NumberCheck(this.event)">
                    <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationNumberOfJobs">{{OfficeLocationValidationResult.OfficeLocationNumberOfJobs}}</p>
                </div>
            </div>
        </div>

        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <label class="account_label">
              How do you plan on serving those patients?
            </label>
            <br/>
            <div class="form-check">
              <input
                class="form-check-input"
                value="Serve walk ins and sporadic referrals in my office"
                v-model="forcastServices"
                type="checkbox"
                v-on:change="onChangeServices"
              />
              Serve walk ins and sporadic referrals in my office
              <br/>
              <input
                class="form-check-input"
                value="Host a vision event(s)"
                v-model="forcastServices"
                type="checkbox"
                v-on:change="onChangeServices"
              />
              Host a vision event(s)
              <br/>
              <input
                class="form-check-input"
                value="Partner with a local non profit or school to receive their referrals in my office"
                v-model="forcastServices"
                type="checkbox"
                v-on:change="onChangeServices"
              />
              Partner with a local non profit or school to receive their referrals in my office
              <br/>
              <input
                class="form-check-input"
                value="Volunteer at local clinics, health fairs, or vision events"
                v-model="forcastServices"
                type="checkbox"
                v-on:change="onChangeServices"
              />
              Volunteer at local clinics, health fairs, or vision events
              <br/>
              <input
                class="form-check-input"
                value="I’m not sure"
                v-model="forcastServices"
                type="checkbox"
                v-on:change="onChangeServices"
              />
                I’m not sure
            </div>
          </div>
        </div>
        <div class="row" v-show="AccountEdit.primaryContact.officeLocation.numberOfJobs >= 100">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                 <label class="account_label">Monthly Breakdown:</label>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <span v-show="AccountEdit.primaryContact.officeLocation.numberOfJobs >= 100">Due to the high pledge/forecast, please break out your estimate by month.</span>
                    <span class="g-mb-0" style="display: block;">
                        <small>
                            <i>If there is a difference, your monthly total will replace your pledged number of orders</i>
                        </small>
                    </span>
                    <div class="table-responsive" v-show="AccountEdit.primaryContact.officeLocation.numberOfJobs >= 100">
                        <table class="table table-bordered">
                            <thead>
                                <tr class="text-center">
                                    <th scope="col">Jan</th>
                                    <th scope="col">Feb</th>
                                    <th scope="col">Mar</th>
                                    <th scope="col">Apr</th>
                                    <th scope="col">May</th>
                                    <th scope="col">Jun</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><input ref="january_input" type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.january" v-bind:disabled="currentMonth > 1" class="form-control pledge-input"></td>
                                    <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.february" v-bind:disabled="currentMonth > 2" class="form-control pledge-input"></td>
                                    <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.march" v-bind:disabled="currentMonth > 3" class="form-control pledge-input"></td>
                                    <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.april" v-bind:disabled="currentMonth > 4" class="form-control pledge-input"></td>
                                    <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.may" v-bind:disabled="currentMonth > 5" class="form-control pledge-input"></td>
                                    <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.june" v-bind:disabled="currentMonth > 6" class="form-control pledge-input"></td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table table-bordered">
                            <thead>
                                <tr class="text-center">
                                    <th scope="col">Jul</th>
                                    <th scope="col">Aug</th>
                                    <th scope="col">Sep</th>
                                    <th scope="col">Oct</th>
                                    <th scope="col">Nov</th>
                                    <th scope="col">Dec</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.july" v-bind:disabled="currentMonth > 7" class="form-control pledge-input"></td>
                                    <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.august" v-bind:disabled="currentMonth > 8" class="form-control pledge-input"></td>
                                    <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.september" v-bind:disabled="currentMonth > 9" class="form-control pledge-input"></td>
                                    <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.october" v-bind:disabled="currentMonth > 10" class="form-control pledge-input"></td>
                                    <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.november" v-bind:disabled="currentMonth > 11" class="form-control pledge-input"></td>
                                    <td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="AccountEdit.primaryContact.officeLocation.jobs.december" v-bind:disabled="currentMonth > 12" class="form-control pledge-input"></td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="border: 1px solid #ccc; padding: 10px;">
                            <p style="margin: 0; text-align: right"><b>Total: {{total}}</b></p>
                        </div>
                    </div>
                    <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationJobs">{{OfficeLocationValidationResult.OfficeLocationJobs}}</p>

            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    props: ['AccountEdit', 'ForcastServices', 'FormInputs', 'OfficeLocationValidationResult'],
    data(){
        return {
            isInviteDoctor:false,
            total:0,
            currentMonth: 0,
            forcastServices: []
        }
    },
    computed: {
      computedOfficeLocation() {
        return this.AccountEdit.primaryContact.officeLocation;
      },
    },
    watch: {
      total(val) {
        if (val >= 100)
          this.computedOfficeLocation.numberOfJobs = val;
      }
    },
    methods:{
        TotalJobs(){
            this.total = ((this.AccountEdit.primaryContact.officeLocation.jobs.january ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.january) : 0) +
            ((this.AccountEdit.primaryContact.officeLocation.jobs.february ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.february): 0) +
            ((this.AccountEdit.primaryContact.officeLocation.jobs.march ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.march): 0) +
            ((this.AccountEdit.primaryContact.officeLocation.jobs.april ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.april): 0) +
            ((this.AccountEdit.primaryContact.officeLocation.jobs.may ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.may): 0) +
            ((this.AccountEdit.primaryContact.officeLocation.jobs.june ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.june): 0) +
            ((this.AccountEdit.primaryContact.officeLocation.jobs.july ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.july): 0) +
            ((this.AccountEdit.primaryContact.officeLocation.jobs.august ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.august): 0) +
            ((this.AccountEdit.primaryContact.officeLocation.jobs.september ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.september): 0) +
            ((this.AccountEdit.primaryContact.officeLocation.jobs.october ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.october): 0) +
            ((this.AccountEdit.primaryContact.officeLocation.jobs.november ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.november): 0) +
            ((this.AccountEdit.primaryContact.officeLocation.jobs.december ) ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.december): 0);
        },
        onChangeServices() {
          this.$emit('setUpdatedServices', this.forcastServices);
        }
    },
    created(){
        this.TotalJobs();
        this.currentMonth = new Date().getMonth() + 1;
        this.forcastServices = [...this.ForcastServices];
    }
}
</script>



// WEBPACK FOOTER //
// EditForecastingInfo.vue?c750fa5a